import React from 'react'
import type { FC } from 'react'
import clsx from 'clsx'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
interface IProps {
  content: string
  className?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&': { ...theme.typography.body1 },
      '& h1': {
        ...theme.typography.h1,
        marginBottom: 20,
      },
      '& h2': {
        ...theme.typography.h2,
        marginBottom: 20,
      },
      '& h3': {
        ...theme.typography.h3,
        marginBottom: 20,
      },
      '& h4': {
        ...theme.typography.h4,
        marginBottom: 20,
      },
      '& h5': {
        ...theme.typography.h5,
      },
      '& h6': {
        color: theme.colors.gold,
        fontSize: 14,
        margin: '25px 0 10px 0',
        fontFamily: 'Messina, Chronicle',
        fontWeight: 400,
        lineHeight: '23.6px',
        letterSpacing: 0,
      },
      '& a': {
        color: theme.colors.gold,
      },
      '& p + h2, & ul + h2, & a + h2': {
        marginTop: 40,
      },
      '& p + h3, & ul + h3, & a + h3': {
        marginTop: 30,
      },
      '& p + h4, & ul + h4, & a + h4': {
        marginTop: 30,
      },
      '& p + h5, & ul + h5, & a + h5': {
        marginTop: 25,
      },
      '& p + p': {
        marginTop: 15,
      },
      '& p + a': {
        marginTop: 15,
      },
      '& p + ul, & ul + ul': {
        marginTop: 15,
      },
      '& p + ol, & ol + ol': {
        marginTop: 15,
      },
      '& ul': {
        '& li': {
          position: 'relative',
          paddingLeft: 25,
          marginBottom: 7,
          '&:before': {
            content: '""',
            width: 12,
            height: 1,
            backgroundColor: theme.colors.gold,
            position: 'absolute',
            left: 0,
            top: '.6em',
          },
        },
      },
      '& ol': {
        listStyle: 'none',
        '& li': {
          display: 'flex',
          counterIncrement: 'list-number',
          position: 'relative',
          paddingLeft: 25,
          marginBottom: 7,
          '&:before': {
            content: 'counter(list-number)"."',
            position: 'absolute',
            left: 0,
            top: 0,
          },
        },
      },
      '& *:last-child': {
        marginBottom: 0,
      },
    },
    title: {
      marginBottom: theme.spacing(2.5),
    },
    ratings: {
      display: 'flex',
      marginTop: theme.spacing(3.75),
      marginBottom: theme.spacing(1.25),
    },
    rating: {
      marginRight: theme.spacing(5),
    },
    replyTitle: {
      marginTop: theme.spacing(1.5),
      marginBottom: `15px!important`,
      color: `${theme.colors.primary}!important`,
    },
    reviewQuestions: {},
    reviewQuestion: {
      marginTop: 15,
    },
    reviewQuestionContent: {},
    reviewQuestionTitle: {
      marginBottom: 5,
    },
    replyContent: {},
    reviewContent: {},
    replyAuthor: {
      fontWeight: 600,
      marginTop: 15,
      '& span': {
        fontWeight: 400,
      },
    },
  }),
)

const RichText: FC<IProps> = ({ content, className }) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.root, 'l-richTextWrapper', className)}>
      <div
        className="l-richText"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  )
}

export default RichText
